module.exports = __webpack_public_path__ + "img/welfare-3.efa54a37.png";